import { PreviousRouteService } from '../../../../../shared/src/lib/service/previous-route.service';
import { OccurrenceService } from '../../../../../shared/src/lib/service/occurrence.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Occurrence } from '../../../../../shared/src/lib/model/occurrence.model';
import { ExerciceSheet } from '../../../../../shared/src/lib/model/exerciceSheet.model';
import { Formation } from '../../../../../shared/src/lib/model/formation.model';
import { FormationService } from '../../../../../shared/src/lib/service/formation.service';
import { Exercice } from '../../../../../shared/src/lib/model/exercice.model';
import { ExerciceAssignComponent } from '../../../../../shared/src/lib/feature/exercice-assign/exercice-assign.component';

@Component({
  selector: 'app-report-offsite-assign',
  templateUrl: './report-offsite-assign.component.html',
  styleUrls: ['./report-offsite-assign.component.scss']
})
export class ReportExerciceOffsiteAssignComponent implements OnInit {
  @ViewChild('exerciceAssign') exerciceAssign!: ExerciceAssignComponent;
  formation: Formation = null;
  exercice: Exercice = null;
  previousUrl

  isCreating = false;

  type: string;
  id: string;

  constructor(
    private route: ActivatedRoute,
    private previousRouteService: PreviousRouteService,
    private formationService: FormationService
  ) { }

  ngOnInit() {
    this.previousUrl = this.previousRouteService.getPreviousUrl();
    this.type = this.route.snapshot.paramMap.get('type')!;
    this.id = this.route.snapshot.paramMap.get('id')!;

    this.formationService.getObservableFormationById(this.id).subscribe(formation => {
      if (formation) {
        this.formation = formation;
      }
    })
  }

  showSheet(object) {
    this.exercice = object.sheet;
    this.isCreating = false;
  }

  createSheet() {
    this.isCreating = true;
  }

  reportSheetAdded(isSheetAdded) {
    if (isSheetAdded) {
    }
  }

  reloadList(exercice: Exercice) {
    this.exercice = exercice;
    this.isCreating = false;
   if (this.exerciceAssign) {
     this.exerciceAssign.assignSheetToClass(exercice);
   }
  }
}
